import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import PowerMeterDashboard from './components/PowerMeterDashboard';

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <PowerMeterDashboard />
      </div>
    </Provider>
  );
}

export default App;